import { types, getRoot } from 'mobx-state-tree';
import Order from '@stores/Order';
import axios from 'axios';


export default types.model('Beriksson',
    {
        

    })
    .views(self => ({
        get navigation() {
            return getRoot(self).navigation;
        },

        get order() {
            return getRoot(self).order;
        }
    }))
    .actions(self => {
        return {
            async contactForm(values) {
                const res = await self.request("/Umbraco/Api/Beriksson/ContactForm",
                    values);

                if (res.status && res.status === "error") {
                    throw res;
                }

                return res;

            },
            
            async register(values) {
                const res = await self.request("/Umbraco/Api/Beriksson/Register",
                    values);

                if (res.status && res.status === "error") {
                    throw res;
                }
                
                return res;
                
            },
            
            async newsletterSignup(values) {
                const res = await self.request("/Umbraco/Api/Beriksson/NewsletterSignup",
                    {...values,
                        CustomerId: self.navigation.getCustomerId(),
                        CultureCode: self.navigation.CultureCode}
                );

                if (res.status && res.status === "error") {
                    throw res;
                }

                return res;

            },
            
            async customerAccount(values) {
                const res = await self.request("/Umbraco/Api/Beriksson/CustomerAccount",
                    {...values,
                        CustomerId: self.navigation.getCustomerId(),
                        CultureCode: self.navigation.CultureCode}
                );

                if (res.status && res.status === "error") {
                    throw res;
                }

                return res;
            },
            
            

            async customerAccountUpdate(values) {
                const res = await self.request("/Umbraco/Api/Beriksson/CustomerAccountUpdate",
                    {...values,
                        CustomerId: self.navigation.getCustomerId(),
                        CultureCode: self.navigation.CultureCode}
                );

                if (res.status && res.status === "error") {
                    throw res;
                }

                return res;
            },

            async customerAccountAdmin(values) {
                const res = await self.request("/Umbraco/Api/Beriksson/CustomerAccountAdmin",
                    {...values,
                        CustomerId: self.navigation.getCustomerId(),
                        CultureCode: self.navigation.CultureCode}
                );

                if (res.status && res.status === "error") {
                    throw res;
                }

                return res;
            },

            async customerAccountEmailUpdate(values) {
                const res = await self.request("/Umbraco/Api/Beriksson/CustomerAccountEmailUpdate",
                    {...values,
                        CustomerId: self.navigation.getCustomerId(),
                        CultureCode: self.navigation.CultureCode}
                );

                if (res.status && res.status === "error") {
                    throw res;
                }

                return res;
            },

            async customerAccountAdminUpdate(values) {
                const res = await self.request("/Umbraco/Api/Beriksson/CustomerAccountAdminUpdate",
                    {...values,
                        CustomerId: self.navigation.getCustomerId(),
                        CultureCode: self.navigation.CultureCode}
                );

                if (res.status && res.status === "error") {
                    throw res;
                }

                return res;
            },
            
            


            async customerAccountAddresses(values) {
                const res = await self.request("/Umbraco/Api/Beriksson/CustomerAccountAddresses",
                    {...values,
                        CustomerId: self.navigation.getCustomerId(),    
                        CultureCode: self.navigation.CultureCode}
                );

                if (res.status && res.status === "error") {
                    throw res;
                }

                return res;
            },

            async customerAccountAddressDelete(customerAddressId) {
                const res = await self.request("/Umbraco/Api/Beriksson/CustomerAccountAddressDelete",
                    {
                        CustomerAddressId: customerAddressId,
                        CustomerId: self.navigation.getCustomerId(),
                        CultureCode: self.navigation.CultureCode}
                );

                if (res.status && res.status === "error") {
                    throw res;
                }

                return res;
            },
            

            async customerAccountUsers(values) {
                const res = await self.request("/Umbraco/Api/Beriksson/CustomerAccountUsers",
                    {...values,
                        CustomerId: self.navigation.getCustomerId(),
                        CultureCode: self.navigation.CultureCode}
                );

                if (res.status && res.status === "error") {
                    throw res;
                }

                return res;
            },


            async customerAccountAddressUpdate(values) {
                const res = await self.request("/Umbraco/Api/Beriksson/CustomerAccountAddressUpdate",
                    {...values,
                        CustomerId: self.navigation.getCustomerId(),
                        CultureCode: self.navigation.CultureCode
                        }
                );

                if (res.status && res.status === "error") {
                    throw res;
                }

                return res;
            },

            async customerAccountUserUpdate(values) {
                const res = await self.request("/Umbraco/Api/Beriksson/CustomerAccountUserUpdate",
                    {...values,
                        CustomerId: self.navigation.getCustomerId(),
                        CultureCode: self.navigation.CultureCode
                    }
                );

                if (res.status && res.status === "error") {
                    throw res;
                }

                return res;
            },


            async customerList(values,  cancelToken) {
                const res = await self.request("/Umbraco/Api/Beriksson/CustomerList", 
                    {
                        ...values,
                        CustomerId: self.navigation.getCustomerId(),
                        CultureCode: self.navigation.CultureCode 
                    } ,
                    {
                        cancelToken: cancelToken
                    });
                return res;
            },


            async inviteUser(id, email, message) {
                const res = await self.request("/Umbraco/Api/Beriksson/InviteUser",
                    {
                        Id: id,
                        Email: email,
                        Message: message,
                        CultureCode: self.navigation.CultureCode,
                        CustomerId: self.navigation.getCustomerId()
                    });
                console.debug("inviteUser result:", res);
                return res;
            },


            async myProfile(values) {
                const res = await self.request("/Umbraco/Api/Beriksson/MyProfile",
                    {...values,
                        CustomerId: self.navigation.getCustomerId(),
                        CultureCode: self.navigation.CultureCode}
                );

                if (res.status && res.status === "error") {
                    throw res;
                }

                return res;
            },

            async myProfileUpdate(values) {
                const res = await self.request("/Umbraco/Api/Beriksson/MyProfileUpdate",
                    {...values,
                        CustomerId: self.navigation.getCustomerId(),
                        CultureCode: self.navigation.CultureCode}
                );

                if (res.status && res.status === "error") {
                    throw res;
                }

                return res;
            },
            
            
            // async addComplaint(siteId, setActive = false) {
            //
            //     console.debug("addOrder", self.navigation.getCustomerId());
            //     const res = await self.request("/Umbraco/Api/ActorOrder/Add",
            //         {
            //
            //             CustomerId: self.navigation.getCustomerId(),
            //             SiteId: siteId ? siteId : self.navigation.SiteId,
            //             CultureCode: self.navigation.CultureCode,
            //             CountryCode: self.navigation.CountryCode,
            //             Parameters: {
            //                 OrderProperties: [
            //                     { Key: "Reference", Value: "" },
            //                     { Key: "OrderTemplateName", Value: "Complaint B2B" }
            //                 ]
            //             }
            //         });
            //
            //     if (res.status && res.status === "error") {
            //         throw res;
            //     }
            //
            //     self.order.setOrders(res.Orders);
            //
            //     const newOrder =
            //         self.order.Orders.filter(x => !x.IsPurchaseOrder);
            //    
            //     if (setActive && newOrder) {
            //         self.getComplaint(newOrder[newOrder.length - 1].OrderGuid, true);
            //     }
            //
            //     return res;
            // },
            //

            async toggleFavorite(sku, cancelToken) {
                const res = await self.request("/Umbraco/Api/Beriksson/ToggleFavorite",
                    {
                        Sku: sku,
                        CustomerId: self.navigation.getCustomerId(),
                        SiteId: self.navigation.SiteId,
                        MarketCode: self.navigation.MarketCode,
                        CultureCode: self.navigation.CultureCode,
                        CountryCode: self.navigation.CountryCode,
                    },
                    {
                        cancelToken: cancelToken
                    });

                return res;

            },


            async request(path, query = {}, options) {
                const res = await axios.post(`${path}`, query, options);
                return res.data;
            }
        }
    });




